export const statusColor = (s) => ({
  "Recebida": "bg-blue-100 text-blue-800",
  "Em Triagem": "bg-yellow-100 text-yellow-800",
  "Documentação Pendente": "bg-orange-100 text-orange-800",
  "Em Análise": "bg-purple-100 text-purple-800",
  "Aprovada": "bg-green-100 text-green-800",
  "Indeferida": "bg-red-100 text-red-800",
  "Homologada": "bg-emerald-100 text-emerald-800",
}[s] || "bg-slate-100");

// Tipos de documento aceitos pelo backend (devem bater com SucessoPage).
export const DOC_TIPOS = [
  { key: "cpf", label: "CPF", obrigatorio: true },
  { key: "rg", label: "RG", obrigatorio: true },
  { key: "comprovante_residencia", label: "Comprovante de Residência", obrigatorio: true },
  { key: "cadunico", label: "Folha Resumo CadÚnico", obrigatorio: true },
  { key: "certidao_casamento", label: "Certidão de Casamento", obrigatorio: false, condicional: "Se casado(a)/união estável" },
  { key: "certidao_nascimento", label: "Certidão de Nascimento (filhos)", obrigatorio: false, condicional: "Se possui filhos" },
  { key: "laudo_pcd", label: "Laudo PCD", obrigatorio: false, condicional: "Se declarou PCD" },
  { key: "cnh", label: "CNH", obrigatorio: false },
  { key: "outros", label: "Outros", obrigatorio: false },
];

export const docsObrigatoriosFaltando = (documentos = []) =>
  DOC_TIPOS.filter((t) => t.obrigatorio && !documentos.find((d) => d.tipo === t.key));

export function fmtDataHora(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", { timeZone: "America/Fortaleza" });
  } catch { return iso; }
}
